export default __webpack_public_path__ + "static/media/face.0900e2f8.svg";